"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openMiniBasket = void 0;
var openMiniBasket = exports.openMiniBasket = function openMiniBasket(event) {
  if (window.isMinibasketLoaded) {
    event.preventDefault();
    window.dispatchEvent(new CustomEvent('jl-events.browser.showMinibasket', {
      detail: {
        source: 'page'
      }
    }));
  }
};